import config from "./config";
import data from "./data";
import dashboards from "./dashboards";
import globalReducers from "./global";
import login from "./login";
import routes from "./routes";
import uiState from "./uiState";
import windowSize from "./windowSize";
import messages from "./messages";
import notifications from "./notifications";
import actions from "./actions";

export default {
    config: config,
    data: data,
    dashboards,
    global: globalReducers,
    login: login,
    routes: routes,
    uiState: uiState,
    windowSize: windowSize,
    messages,
    notifications,
    actions
};
